import { useEffect, useState } from 'react'

import { api } from '../../lib/api'
import { money } from '../../lib/format'
import type { Overview } from '../../lib/types'

export default function OverviewPage() {
  const [data, setData] = useState<Overview | null>(null)

  useEffect(() => {
    api.overview().then(setData).catch(() => {})
  }, [])

  if (!data) return <div className="skeleton" style={{ height: 120 }} />

  const stats = [
    { label: 'Documents', value: String(data.documents), note: 'all time' },
    { label: 'Needs review', value: String(data.needs_review), note: 'waiting on a human' },
    {
      label: 'Auto-approved',
      value: `${(data.auto_approve_rate * 100).toFixed(0)}%`,
      note: `${data.auto_approved} of ${data.approved} approved`,
    },
    { label: 'Invoiced value', value: money(data.invoiced_value), note: 'approved total' },
    {
      label: 'Model spend',
      value: `$${data.model_spend_usd.toFixed(4)}`,
      note: data.documents
        ? `$${(data.model_spend_usd / data.documents).toFixed(5)} per document`
        : '—',
    },
  ]

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div className="stat-row">
        {stats.map((s) => (
          <div className="stat" key={s.label}>
            <div className="stat-label">{s.label}</div>
            <div className="stat-value">{s.value}</div>
            <div className="stat-note">{s.note}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-head"><span className="card-title">How confidence is scored</span></div>
        <div className="card-body" style={{ fontSize: 13, color: 'var(--text-2)' }}>
          <p style={{ marginTop: 0 }}>
            Field confidence here is computed, not reported by the model. In testing the
            extraction model returned an invalid 14-character GSTIN and a wrong line total
            while claiming 0.98 confidence on both, so its self-assessment is weighted zero.
          </p>
          <div className="field-grid" style={{ gridTemplateColumns: '90px 1fr', gap: '4px 12px' }}>
            <span className="mono">0.35</span>
            <span>Deterministic rules touching the field — checksums and arithmetic</span>
            <span className="mono">0.30</span>
            <span>Agreement between the primary and adjudicator models</span>
            <span className="mono">0.20</span>
            <span>How often a human has corrected this field for this vendor</span>
            <span className="mono">0.15</span>
            <span>Format prior — regex, checksum or enum for the field type</span>
          </div>
        </div>
      </div>
    </div>
  )
}
